export default "__VITE_ASSET__55711b20__"